var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPin = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.225 3.48c.204-1.428 1.95-2.01 2.97-.99l4.242 4.242c1.02 1.02.438 2.766-.99 2.97l-.79.113a1.79 1.79 0 0 0-1.535 1.77c0 1.421-1.72 2.133-2.725 1.128L3.214 8.53C2.21 7.525 2.921 5.806 4.343 5.806c.89 0 1.643-.654 1.769-1.535zm1.91.07a.25.25 0 0 0-.425.142l-.113.791a3.29 3.29 0 0 1-3.254 2.823.1.1 0 0 0-.055.013.1.1 0 0 0-.034.046.1.1 0 0 0-.008.056c.002.01.006.026.029.048l4.183 4.183c.023.023.038.027.048.03a.1.1 0 0 0 .057-.009.1.1 0 0 0 .045-.034c.006-.008.014-.022.014-.054a3.29 3.29 0 0 1 2.822-3.255l.791-.113a.25.25 0 0 0 .142-.424z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.338 10.588a.125.125 0 0 0-.188.014l-1.95 2.6c-.26.347.178.785.525.525l2.6-1.95a.125.125 0 0 0 .013-.189z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export default ForwardRef;